import _constants from "../shared/constants";
import _useMin from "../../lib/use-min";
var exports = {};
var constants = _constants;
var useMin = _useMin;
exports = function composeUrl(assetsUrl, componentId, isDebug) {
  return assetsUrl + "/web/" + constants.VERSION + "/html/hosted-fields-frame" + useMin(isDebug) + ".html#" + componentId;
};
export default exports;